// import { Box, Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import VerifyVoucher from "../Vouchers/VerifyVoucher"
import { endpoints } from "../../hooks/use-api";

const OrderHomeOld = () => {
  const [done, setDone] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");

  useEffect(() => {
    if (done) {
      window.location.href = redirectUrl;
    }
  }, [done, redirectUrl]);

  const onSuccess = (responseData, formData) => {
    if (responseData.valid) {
      setRedirectUrl(responseData.redirectUrl);
      setDone(true);
      return [true, ""];
    } else {
      const msg = responseData.message.length > 0 ? responseData.message : `Voucher number ${formData.voucherNumber} is not setup for ordering`;
      return [false, msg]
    }
  }

  return (
    <VerifyVoucher
      title="Order Form"
      endpointFn={endpoints.order.new}
      onSuccess={onSuccess} />
  );
};

export default OrderHomeOld;
